<section class="panel p-4">
  <div class="d-flex justify-content-between align-items-center mb-3 gap-2 flex-wrap">
    <h2 class="h5 mb-0">Cadastro do empregador</h2>
    <button type="button" class="btn btn-outline-success btn-sm" [disabled]="!empregador.id" (click)="gerarAcessosPortal()">
      Gerar acessos
    </button>
  </div>
  <form class="row g-3" (ngSubmit)="salvarEmpregador()">
    <app-seletor-empregador-existente
      [termo]="buscaEmpregador"
      [empregadores]="empregadoresFiltrados"
      [rotuloEmpregador]="rotuloEmpregador"
      [detalheEmpregador]="detalheEmpregador"
      (termoChange)="alterarBusca($event)"
      (buscar)="abrirModalEmpregadores()"
      (selecionar)="selecionarEmpregador($event)">
    </app-seletor-empregador-existente>

    <app-painel-dados-empregador
      class="row g-3"
      [empregador]="empregador"
      [urlTerminal]="urlTerminal"
      (empregadorChange)="empregador = $event"
      (tenantChange)="alterarTenant($event)"
      (carregarLogo)="carregarLogo($event)"
      (removerLogo)="removerLogo()">
    </app-painel-dados-empregador>

    <div class="col-12">
      <app-rodape-crud
        [exibirExcluir]="true"
        [excluirDesabilitado]="!empregador.id"
        (excluir)="excluirEmpregador()"
        (limpar)="limparEmpregador()"
        (salvar)="salvarEmpregador()">
      </app-rodape-crud>
    </div>

    <app-modal-pesquisa-empregador
      [aberta]="modalEmpregadoresAberta"
      [termo]="buscaEmpregadorModal"
      [empregadores]="empregadoresModal"
      [rotuloEmpregador]="rotuloEmpregador"
      [detalheEmpregador]="detalheEmpregador"
      (termoChange)="buscaEmpregadorModal = $event"
      (selecionar)="selecionarEmpregador($event)"
      (limpar)="limparBuscaEmpregadorModal()"
      (fechar)="fecharModalEmpregadores()">
    </app-modal-pesquisa-empregador>
  </form>

  <app-painel-secretarios-empregador
    [empregadorId]="empregador.id || ''"
    (mensagem)="mensagem.emit($event)">
  </app-painel-secretarios-empregador>
</section>
